<form [formGroup]="lotForm" (ngSubmit)="onSubmit()" class="needs-validation h-100">
  <div class="p-4 border rounded-4 mb-4 bg-white">
    <h3 class="mb-3 text-black"><i class="bi bi-fingerprint me-2"></i>Identifiers</h3>
    <div class="row gy-3">
      <div class="col-lg-4">
        <input-field
          label="Lot Number"
          placeholder="Enter lot no"
          formControlName="lotNo"
          [required]="true"
          errormessage="Lot Number is required"
        ></input-field>
      </div>
      @if (!isEdit) {
        <div class="col-lg-4">
          <generic-dropdown
            label="Operating Unit"
            placeholder="Select Operating Unit"
            [items]="operatingUnits()"
            formControlName="operatingUnitId"
            [required]="true"
            errormessage="Operating Unit is required"
          ></generic-dropdown>
        </div>
      }

      <div class="col-lg-4">
        <generic-dropdown
          label="Project Code"
          placeholder="Select a Project Code"
          [items]="projectsOptions()"
          formControlName="projectCode"
          [required]="true"
          errormessage="Project Code is required"
        ></generic-dropdown>
      </div>

      <div class="col-lg-4">
        <input-field label="War Ref No" placeholder="Enter war ref no" formControlName="warRefNo"></input-field>
      </div>

      <div class="col-md-4">
        <input-field label="Plan No" placeholder="Enter plan no" formControlName="planNo"></input-field>
      </div>

      <div class="col-md-4">
        <input-field label="Permit No" placeholder="Enter permit no" formControlName="permitNo"></input-field>
      </div>
    </div>
  </div>
  <div class="p-4 border rounded-4 mb-4 bg-white">
    <h3 class="mb-3 text-black"><i class="bi bi-layers me-2"></i>Classification</h3>
    <div class="row gy-3">
      <div class="col-md-6">
        <input-field label="Legal Unit" placeholder="Enter legal unit" formControlName="legalUnit"></input-field>
      </div>

      <div class="col-md-6">
        <input-field
          label="Marketing Unit No"
          placeholder="Enter marketing unit no"
          formControlName="mrktgUnitNo"
        ></input-field>
      </div>

      <div class="col-md-6">
        <input-field label="Post Allow" placeholder="Enter post allow" formControlName="postAllow"></input-field>
      </div>

      <div class="col-md-6">
        <generic-dropdown label="Schedule" [items]="schedules()" formControlName="scheduleId"></generic-dropdown>
      </div>

      <div class="col-md-6">
        <generic-dropdown label="Job Type" [items]="jobTypes()" formControlName="jobTypeId"></generic-dropdown>
      </div>
      <div class="col-md-6">
        <generic-dropdown
          label="Lot Type"
          [items]="lotTypes()"
          formControlName="lotTypeId"
          [required]="true"
          errormessage="Lot Type is required"
        ></generic-dropdown>
      </div>

      <div class="col-md-6">
        <generic-dropdown
          label="Swing"
          placeholder="Select Swing"
          [items]="swingOptions"
          [clearable]="true"
          formControlName="swing"
        ></generic-dropdown>
      </div>

      <div class="col-12">
        <label class="form-label">Description</label>
        <textarea
          label="Description"
          placeholder="Enter description"
          formControlName="descr"
          class="form-control"
          rows="3"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="p-4 border rounded-4 mb-4 bg-white">
    <h3 class="mb-3 text-black"><i class="bi bi-cash-stack me-2"></i>Price and Cost</h3>
    <div class="row gy-3">
      <div class="col-md-6">
        <input-field label="Sort Key" placeholder="Enter sort key" formControlName="sortKey"></input-field>
      </div>
      <div class="col-md-6">
        <input-field label="Soft Cost LC" placeholder="Enter soft cost" formControlName="softCostLc"></input-field>
      </div>
      <div class="col-md-6">
        <input-field
          label="Lot Premium Amount"
          placeholder="Enter lot premium amount"
          formControlName="lotPremiumAmount"
        ></input-field>
      </div>
    </div>
  </div>

  <div class="p-4 border rounded-4 mb-4 bg-white">
    <h3 class="mb-3 text-black"><i class="bi bi-link-45deg me-2"></i>Links & Storage</h3>
    <div class="row gy-3">
      <div class="col-lg-4">
        <input-field
          label="Floorplan File Link"
          placeholder="Enter link"
          formControlName="floorplanFileLink"
        ></input-field>
      </div>

      <div class="col-lg-4">
        <label class="form-label">Select Folder</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control btn-h42"
            [value]="lotFolderName()"
            readonly
            placeholder="No folder selected"
          />
          <button class="btn btn-outline-primary btn-h42" type="button" (click)="openFolderModal()">
            <i class="bi bi-folder"></i>
          </button>
        </div>
      </div>

      <div class="col-lg-4">
        <input-field
          label="Buyer Document Link"
          placeholder="Enter link"
          formControlName="buyerDocumentLink"
        ></input-field>
      </div>
    </div>
  </div>

  <div class="p-4 border rounded-4 mb-4 bg-white">
    <h3 class="mb-3 text-black"><i class="bi bi-geo-alt me-2"></i>Address Information</h3>
    <div formGroupName="address" class="row gy-3">
      <div class="col-md-12">
        <input-field label="Address Line 1" formControlName="street"></input-field>
      </div>
      <div class="col-md-12">
        <input-field label="Address Line 2" formControlName="street2"></input-field>
      </div>
      <div class="col-md-6">
        <input-field label="Street Number" formControlName="streetNo"></input-field>
      </div>
      <div class="col-md-6">
        <input-field label="Suite" formControlName="suite"></input-field>
      </div>
      <div class="col-md-6">
        <generic-dropdown
          label="City"
          [items]="cities()"
          formControlName="cityId"
          [virtualScroll]="true"
          [virtualScrollItemSize]="30"
        ></generic-dropdown>
      </div>

      <div class="col-md-6">
        <input-field label="Postal Code" formControlName="postal"></input-field>
      </div>
    </div>
  </div>

  <div class="mt-4 d-flex justify-content-end gap-3 sticky-bottom bg-white p-3 border-top">
    <button type="button" class="btn btn-secondary px-4 btn-h42" (click)="onCancel()">Cancel</button>
    <button type="submit" class="btn btn-primary px-4 btn-h42">Save Lot</button>
  </div>
</form>
